// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trimble-search .sui-layout-main-footer ul.rc-pagination {
  display: flex;
  height: 2rem;
  justify-content: center;
  align-items: center;
}

.trimble-search .sui-layout-main-footer ul.rc-pagination > li {
  display: flex;
  min-width: 2rem;
  height: 2rem;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 0.25rem;
  margin: 0;
}

.trimble-search .sui-layout-main-footer ul.rc-pagination > li a {
  color: var(--primary-black);
  text-align: center;
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.trimble-search .sui-layout-main-footer ul.rc-pagination > li:hover {
  background: #e0e1e9;
}

.trimble-search .sui-layout-main-footer ul.rc-pagination > li:focus {
  outline: 2px solid var(--primary-black);
}

.trimble-search .sui-layout-main-footer ul.rc-pagination > li a:hover {
  background: inherit;
  color: #252a2e;
}

.trimble-search .sui-layout-main-footer ul.rc-pagination > li.rc-pagination-item-active {
  background: var(--button-hover-bg-color);
  cursor: default;
}

.trimble-search .sui-layout-main-footer ul.rc-pagination > li.rc-pagination-item-active a {
  color: var(--primary-blue) !important;
  cursor: default;
}

.trimble-search .sui-layout-main-footer ul.rc-pagination > li.rc-pagination-next.rc-pagination-disabled,
.trimble-search .sui-layout-main-footer ul.rc-pagination > li.rc-pagination-prev.rc-pagination-disabled {
  display: none;
}

.trimble-search .sui-layout-main-footer ul.rc-pagination > li.rc-pagination-next svg,
.trimble-search .sui-layout-main-footer ul.rc-pagination > li.rc-pagination-prev svg {
  width: 1.5rem;
  height: 1.5rem;
}

.trimble-search .sui-layout-main-footer ul.rc-pagination > li.rc-pagination-next svg *,
.trimble-search .sui-layout-main-footer ul.rc-pagination > li.rc-pagination-prev svg * {
  fill: #6a6e79;
}

.trimble-search ul.rc-pagination > li.rc-pagination-options {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/results/pagination/pagination.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":[".trimble-search .sui-layout-main-footer ul.rc-pagination {\n  display: flex;\n  height: 2rem;\n  justify-content: center;\n  align-items: center;\n}\n\n.trimble-search .sui-layout-main-footer ul.rc-pagination > li {\n  display: flex;\n  min-width: 2rem;\n  height: 2rem;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  border-radius: 0.25rem;\n  margin: 0;\n}\n\n.trimble-search .sui-layout-main-footer ul.rc-pagination > li a {\n  color: var(--primary-black);\n  text-align: center;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 0.875rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.trimble-search .sui-layout-main-footer ul.rc-pagination > li:hover {\n  background: #e0e1e9;\n}\n\n.trimble-search .sui-layout-main-footer ul.rc-pagination > li:focus {\n  outline: 2px solid var(--primary-black);\n}\n\n.trimble-search .sui-layout-main-footer ul.rc-pagination > li a:hover {\n  background: inherit;\n  color: #252a2e;\n}\n\n.trimble-search .sui-layout-main-footer ul.rc-pagination > li.rc-pagination-item-active {\n  background: var(--button-hover-bg-color);\n  cursor: default;\n}\n\n.trimble-search .sui-layout-main-footer ul.rc-pagination > li.rc-pagination-item-active a {\n  color: var(--primary-blue) !important;\n  cursor: default;\n}\n\n.trimble-search .sui-layout-main-footer ul.rc-pagination > li.rc-pagination-next.rc-pagination-disabled,\n.trimble-search .sui-layout-main-footer ul.rc-pagination > li.rc-pagination-prev.rc-pagination-disabled {\n  display: none;\n}\n\n.trimble-search .sui-layout-main-footer ul.rc-pagination > li.rc-pagination-next svg,\n.trimble-search .sui-layout-main-footer ul.rc-pagination > li.rc-pagination-prev svg {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.trimble-search .sui-layout-main-footer ul.rc-pagination > li.rc-pagination-next svg *,\n.trimble-search .sui-layout-main-footer ul.rc-pagination > li.rc-pagination-prev svg * {\n  fill: #6a6e79;\n}\n\n.trimble-search ul.rc-pagination > li.rc-pagination-options {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
